import React, { useState } from 'react';
import { Input } from 'antd';
import { useQueryClient } from 'react-query';
import Modal from '../../../components/Modal';
import { useUpdateTitle } from '../../../core/modules/book/hooks/useUpdateTitle.query';
import { CONTACTED, CONTACTED_RR, SOURCE } from '../../../core/constants';
import { IBook } from '../../../section/Common/types/types';
import showNotification from '../../../section/Common/utils/showNotification';
import { useActions } from '../../../context/Actions.context';

const { TextArea } = Input;

interface IProps {
  book: IBook | Record<string, string | number>;
  modal: boolean;
  toggleModal: Function;
  id: string;
}

const createContactedObject = (source: string, book: IBook | Record<string, string | number>) => {
  if (source === SOURCE.bookstat) {
    return { amazonasin: book.ASIN };
  } else {
    return { fiction_id: book['Fiction Id'] };
  }
};

const getContactedType = (source: string) => {
  if (source === SOURCE.bookstat) {
    return CONTACTED;
  } else {
    return CONTACTED_RR;
  }
};

const ContactedTitles: React.FC<IProps> = ({ book, modal, toggleModal, id }) => {
  const { source, isActionLoading, setActionLoading } = useActions();
  const queryClient = useQueryClient();
  const contacted = createContactedObject(source['source'], book);
  const contactedType = getContactedType(source['source']);
  const titleForNotification = typeof book?.Title === 'string' ? book.Title : undefined;
  const [notes, setNotes] = useState<string>('');

  const { mutateAsync: mutateContacted } = useUpdateTitle(contactedType);

  const handleClose = () => {
    setNotes('');
    toggleModal();
  };

  const onSend = () => {
    setActionLoading(true);

    const body = {
      ...(notes.trim() && { notes: notes.trim() })
    };

    const promise = mutateContacted({ params: contacted, body });

    showNotification(
      promise,
      'The Title was successfully sent to the Contacted tab.',
      'The Title has not been sent to the Contacted tab.',
      titleForNotification
    );

    promise.then(() => queryClient.refetchQueries(`get-row-count${id}`));
    promise.then(() => queryClient.refetchQueries(`get-${id}`));
    promise.finally(() => setActionLoading(false));

    handleClose();
  };

  return (
    <Modal
      okText={'Send To Contacted'}
      title='Send To Contacted'
      visible={modal}
      onOk={onSend}
      confirmLoading={isActionLoading}
      onCancel={handleClose}
    >
      <div>
        <span>
          Help yourself and others understand why you&apos;re sending this. Leave a note, or skip and
          continue.
        </span>
        <br />
        <br />
        <TextArea
          placeholder='Add your notes here...'
          maxLength={400}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows={4}
        />

        <div style={{ textAlign: 'right', fontSize: 12, marginTop: 4 }}>
          {notes.length} / 400
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(ContactedTitles);